import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import { tickerValidator } from "../../globalVariables";
import { SHARING_TYPE } from "../../Common/constants";

function bookableEntityToListValuesMapper({ entities, currentLocale }) {
  return entities.map(oldEntity => {
    const entity = { ...oldEntity };
    const currentTranslation =
      entity.translations &&
      entity.translations.find(translation => translation.locale === currentLocale);

    entity.name = currentTranslation ? currentTranslation.name : entity.name;

    return entity;
  });
}

const ModuleDefinition = {
  name: "Bookable",
  entityName: "bookable",
  restConfig: null,
  renderers: {
    list: {},
    form: {},
  },
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Translations",
    widget: "translations",
    entityProperty: "translations",
    localeProperty: "language",
  },
  sorting: {
    property: "arrangement",
    sortable: true,
  },
  reorder: true,
  fields: {
    list: [
      {
        fieldName: "arrangement",
        displayName: "Order",
        sortProperty: true,
      },
      {
        fieldName: "isActive",
        displayName: "Activo",
        widget: "singleSwitch",
        defaultValue: false,
        toggleAction: true,
        order: 10,
        width: 60,
        disabled: ({ entity }) =>
          entity.sharingType &&
          entity.sharingType === SHARING_TYPE.SHARED &&
          entity.parentPropertyTicker,
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
        widget: "singleSwitch",
        defaultValue: false,
        toggleAction: true,
        order: 20,
        width: 60,
        disabled: ({ entity }) =>
          entity.sharingType &&
          entity.sharingType === SHARING_TYPE.SHARED &&
          entity.parentPropertyTicker,
      },
      {
        fieldName: "ticker",
        displayName: "Identificador",
        order: 30,
        width: 200,
      },
      {
        fieldName: "name",
        displayName: "Nombre",
        translated: true,
        order: 40,
        width: 200,
      },
      {
        widget: "promotionsType",
        fieldName: "rate",
        displayName: "Tipología",
        helpText:
          "Porcentaje de descuento o importe fijo por noche que se aplicará al precio de alojamiento sujeto a la promoción. Para mostrar como texto destacado en lugar de promoción, ponga 0.",
        order: 50,
        width: 80,
      },
    ],
    form: [
      {
        fieldName: "id",
        widget: "hidden",
        order: 10,
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
        order: 20,
      },
      {
        fieldName: "arrangement",
        widget: "hidden",
      },
      {
        fieldName: "isActive",
        displayName: "Activo",
        widget: "singleSwitch",
        order: 30,
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
        widget: "singleSwitch",
        order: 40,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        className: "tickerInput",
        widget: "input",
        readOnly: true,
        required: true,
        order: 60,
      },
      {
        fieldName: "name",
        displayName: "Nombre",
        widget: "input",
        required: true,
        translated: true,
        order: 70,
      },
      {
        fieldName: "description",
        displayName: "Descripción",
        widget: "richHTMLEditor",
        required: true,
        translated: true,
        order: 80,
      },
      {
        fieldName: "codesSection",
        displayName: "Código promocional",
        subtitle:
          "Solo aquellos usuarios que introduzcan este código en el motor podrán activar esta promoción",
        widget: "section",
        order: 90,
      },
    ],
  },
  validation: {
    ticker: tickerValidator,
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    description: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });

export { ModuleDefinition, bookableEntityToListValuesMapper };
